import { createTheme } from "@mui/material/styles";

const seniorLivingTheme = createTheme({
  palette: {
    primary: {
      main: "#7B8B59", // Warm Olive Green
      light: "#A5B788",
      dark: "#5C6B3F",
      contrastText: "#222222", // high contrast
    },
    secondary: {
      main: "#FFD97D", // Warm Yellow
      light: "#FFE9A7",
      dark: "#E9C46A",
      contrastText: "#222222", // high contrast
    },
    accent: {
      main: "#A5B788", // Sage Green
      gold: "#FFD97D", // Honey Gold
    },
    background: {
      default: "#FEF5F5", // near white
      paper: "#FEF5F5",
      accent: "#FEF5F5",
    },
    text: {
      primary: "#222222", // high contrast
      secondary: "#222222", // high contrast
      accent: "#7B8B59", // Olive Green for accents
    },
    divider: "#A5B788", // Sage Green for dividers
    error: {
      main: "#B85C5C",
    },
    warning: {
      main: "#FFD97D",
    },
    info: {
      main: "#A5B788", // Sage Green
    },
    success: {
      main: "#7B8B59", // Olive Green
    },
  },
  typography: {
    fontFamily:
      '"Poppins", "Inter", "Source Sans Pro", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 800,
      fontSize: "3.5rem",
      lineHeight: 1.1,
      color: "#222222", // high contrast
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: "2.5rem",
      lineHeight: 1.2,
      color: "#222222",
    },
    h3: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.25,
      color: "#222222",
    },
    h4: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.3,
      color: "#222222",
    },
    h5: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
      color: "#222222",
    },
    h6: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 600,
      fontSize: "1.1rem",
      lineHeight: 1.4,
      color: "#222222",
    },
    body1: {
      fontFamily: '"Poppins", sans-serif',
      fontSize: "1.5rem", // 24px ~ 18pt
      lineHeight: 1.7,
      color: "#222222",
    },
    body2: {
      fontFamily: '"Poppins", sans-serif',
      fontSize: "1.5rem", // 24px ~ 18pt
      lineHeight: 1.6,
      color: "#222222",
    },
    button: {
      fontFamily: '"Poppins", sans-serif',
      textTransform: "none",
      fontWeight: 700,
      fontSize: "1.2rem",
      letterSpacing: "0.01em",
      color: "#222222",
    },
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "36px",
          padding: "18px 36px",
          fontWeight: 700,
          fontSize: "1.2rem", // Slightly larger for better readability
          boxShadow: "0 6px 20px rgba(165, 183, 136, 0.10)",
          transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
          "&:hover": {
            backgroundColor: "#FFD97D",
            color: "#5C4B3A",
            boxShadow: "0 12px 32px rgba(165, 183, 136, 0.18)",
          },
        },
        contained: {
          backgroundColor: "#FFD97D",
          color: "#5C4B3A",
          "&:hover": {
            backgroundColor: "#A5B788",
            color: "#FFF",
          },
        },
        outlined: {
          borderColor: "#A5B788",
          color: "#A5B788",
          backgroundColor: "#FFF8E1",
          "&:hover": {
            borderColor: "#FFD97D",
            backgroundColor: "#FFD97D22",
            color: "#5C4B3A",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
          boxShadow: "0 8px 32px rgba(92, 75, 58, 0.10)",
          backgroundColor: "#FAF6F0",
          transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
          "&:hover": {
            transform: "scale(1.04) translateY(-4px)",
            boxShadow: "0 16px 48px rgba(165, 183, 136, 0.18)",
            border: "2px solid #FFD97D",
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "#FAF6F0",
          borderRadius: "16px",
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: "10px 0",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          "&.Mui-expanded": {
            minHeight: "64px",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "#FAF6F0",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "#A5B788",
          opacity: 0.7,
        },
      },
    },
  },
});

export default seniorLivingTheme;
